const ApiSuffix = {
  login: "/api/login/",

  isAllowed: "/api/is-allowed/",

  getUsers: "/api/get-all-users/",
  createUser: "/api/create-new-employee/",
  deleteUser: "/api/create-new-employee/",
  projects: "/api/project-crud/",
  tasks: "/api/task-crud/",
  userTasks: "/api/get-task-employee/",
  assignTask: "/api/assign-task/",
  timeline: "/api/update-task-status/",

  getTimeline: "/api/get-task-time-lines/",
  comments: "/api/task-comment/",

  getUserDailyWorkDuration: "/api/user-daily-task-duration/?date=",
  getPermitterUser: "/api/get-permitted-users/",
  userPermissions: "/api/user-permissions/",
  permissionToggle: "/api/user-permission-toggle/",
  sendResetPasswordLink: "/api/send-reset-password-link/?username=",
  resetPassword: "/api/reset-password/",

  submitFCMToken: "/api/register-device-for-notification/ ",

  tags: "/api/tags-crud/",
  taskTags: "/api/task-tags-crud/",

  getAllTickets: "/api/get-all-tickets/",
  getUserTickets: "/api/get-user-tickets/",
  createTicket: "/api/create-ticket/",
  updateTicketStatus: "/api/update-ticket-status/",
  addTicketComment: "/api/ticket-comment/",
  getTicketComment: "/api/ticket-comment/",
  getTicketTimeline: "/api/get-ticket-timeline/",

  getLeaderboard: "/api/leaderboard/",

  createProspectClient: "/api/create-prospect-client/",
  bulkCreateProspectClients: "/api/bulk-prospect-create/",
  updateProspectClient: "/api/update-prospect-client-status/",
  addAssigneeToProspect: "/api/add-assignee-to-prospect-client/",
  getAllProspectClients: "/api/get-all-prospect-clients/",
  getUserAssignedProspectClients: "/api/get-user-assigned-prospect-clients/",
  createProspectFollowUp: "/api/create-prospect-follow-up/",
  getAllProspectFollowUps: "/api/get-all-prospect-followups/",
  getProspectFollowUps: "/api/get-prospect-follow-up/",
  getUserProspectFollowUps: "/api/get-user-prospect-followups/",

  updateUserProfile: "/api/update-profile/",

  getSubscriptionPlan: "/api/get-subscription-plans/",
  cancelSubscription: "/api/cancel-subscription/",
  createSubscription: "/api/create-razorpay-subscription/",
  deleteFCMToken: "/api/delete-fcm-token/",

  getInvoices: "/api/get-invoices/",

  addRepeatTask: "/api/add-repeat-task/",
  addReminder: "/api/add-reminder/",

  googleAuth: "/api/connect-google-drive/",
  googleDrive: "/api/google-drive-document/",

  backlogTasks: "/api/backlog-tasks/",
  adminBacklogTasks: "/api/get-all-backlog-tasks/",
};

export default ApiSuffix;
